// @flow
import React, { Component } from 'react'
import Button from '../Button'

type Props = {
  onCreate: Function,
  onDelete: Function,
  isFavorite: boolean,
  isAuthenticated: boolean,
  onUnauthenticatedClick: Function
}

class FavoriteButton extends Component {
  props: Props

  handleClick = () => {
    if (!this.props.isAuthenticated) {
      this.props.onUnauthenticatedClick()
    } else if (this.props.isFavorite) {
      this.props.onDelete()
    } else {
      this.props.onCreate()
    }
  }

  render() {
    const { isFavorite } = this.props

    return (
      <Button small type="button" onClick={this.handleClick}>
        <span
          className={`fa fa-heart${isFavorite ? '' : '-o'}`}
          style={{ marginRight: '6px' }}
        />
        <span>{isFavorite ? 'Saved' : 'Save'}</span>
      </Button>
    )
  }
}

export default FavoriteButton



// WEBPACK FOOTER //
// ./src/components/FavoriteButton/index.js